import React from 'react';

import AdRow from '../../../components/AdRow/AdRow';
import LineItemGroupHeader from '../../../components/LineItemGroupHeader/LineItemGroupHeader';
import TagRow from '../../../components/TagRow/TagRow';
import type { TagSheetAd } from '../../../types';

const noop = (): void => {};

type ReviewLineItemGroupProps = {
  groupId: string;
  label: string;
  ads: TagSheetAd[];
  startDate?: string | null;
  endDate?: string | null;
  billableEvent?: string | null;
  isExpanded: (id: string) => boolean;
  onToggleExpand: (id: string) => void;
};

const ReviewLineItemGroup = ({
  groupId,
  label,
  ads,
  startDate,
  endDate,
  billableEvent,
  isExpanded,
  onToggleExpand,
}: ReviewLineItemGroupProps): React.JSX.Element => {
  return (
    <tbody>
      <LineItemGroupHeader
        label={label}
        isUnmapped={false}
        adCount={ads.length}
        startDate={startDate}
        endDate={endDate}
        isExpanded={isExpanded(groupId)}
        onToggle={(): void => onToggleExpand(groupId)}
      />
      {isExpanded(groupId) &&
        ads.map((ad) => {
          const adId = ad.id;

          return (
            <React.Fragment key={adId}>
              <AdRow
                ad={ad}
                isExpanded={isExpanded(adId)}
                onToggleExpand={(): void => onToggleExpand(adId)}
                onClone={noop}
                onAddTag={noop}
                onDelete={noop}
                onEditAd={noop}
                readonly
              />
              {isExpanded(adId) &&
                ad.tags.map((tag, tagIndex) => (
                  <TagRow
                    key={`${adId}-tag-${tagIndex}`}
                    tag={tag}
                    siblingTags={ad.tags}
                    onRemove={noop}
                    onEditTag={noop}
                    lineItemBillableEvent={billableEvent}
                    readonly
                  />
                ))}
            </React.Fragment>
          );
        })}
    </tbody>
  );
};

export default ReviewLineItemGroup;
